export default "__VITE_ASSET__qP3oqEPj__"